import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const THRESHOLD = 76;
const MAX_PULL = 118;

export function PullToRefresh({ children }) {
  const [pullDistance, setPullDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const active = useRef(false);
  const distanceRef = useRef(0);
  const refreshingRef = useRef(false);

  useEffect(() => {
    const onStart = (event) => {
      const target = event.target;
      if (window.scrollY > 2 || target?.closest?.("input, textarea, select, [contenteditable='true'], [data-pull-to-refresh-ignore]")) return;
      startY.current = event.touches[0]?.clientY || 0;
      active.current = true;
    };
    const onMove = (event) => {
      if (!active.current || refreshingRef.current) return;
      const delta = (event.touches[0]?.clientY || 0) - startY.current;
      if (delta <= 0 || window.scrollY > 2) { distanceRef.current = 0; setPullDistance(0); return; }
      event.preventDefault();
      distanceRef.current = Math.min(MAX_PULL, Math.round(delta * 0.42));
      setPullDistance(distanceRef.current);
    };
    const onEnd = () => {
      if (!active.current) return;
      active.current = false;
      if (distanceRef.current >= THRESHOLD) { refreshingRef.current = true; setRefreshing(true); window.setTimeout(() => window.location.reload(), 180); return; }
      distanceRef.current = 0;
      setPullDistance(0);
    };
    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onEnd, { passive: true });
    window.addEventListener("touchcancel", onEnd, { passive: true });
    return () => { window.removeEventListener("touchstart", onStart); window.removeEventListener("touchmove", onMove); window.removeEventListener("touchend", onEnd); window.removeEventListener("touchcancel", onEnd); };
  }, []);

  const armed = pullDistance >= THRESHOLD;
  const visibleOffset = refreshing || armed ? 84 : Math.max(-56, pullDistance - 56);
  return <><div aria-live="polite" data-testid="pull-to-refresh-indicator" className="pointer-events-none fixed left-1/2 top-0 z-[100] flex min-h-11 -translate-x-1/2 items-center gap-2 rounded-b-lg border border-[#B8D2DA] bg-white px-4 text-xs font-bold text-[#0E6573] shadow-[0_8px_20px_rgba(11,34,48,0.12)] transition-transform duration-150 sm:hidden" style={{ transform: `translate(-50%, ${visibleOffset}px)` }}><RefreshCw className={`h-4 w-4 ${refreshing ? "animate-spin" : armed ? "" : "rotate-180"}`} /> <span>{refreshing ? "Atualizando…" : armed ? "Solte para atualizar" : "Puxe para atualizar"}</span></div>{children}</>;
}